<template>
  <router-link
    :class="departmentClass"
    :to="fileLink"
    @click.native="$emit('navigated')"
  >{{file.referenceLong}}</router-link>
</template>

<script>
export default {
  name: "File",
  props: ["file"],
  computed: {
    departmentClass() {
      return `department${this.file.departmentId}`;
    },
    fileLink() {
      return {
        name: "file",
        hash: "#fileHeader",
        params: {
          id: this.file.fileId
        }
      };
    }
  }
};
</script>
